//CSS
import "../../Components/Page/Page2.css";
import "../../Components/Page/Page.css";

//React
import React from "react";

interface ScrollPageProps {
  children: React.ReactNode;
  section?: string;
}

const Section: React.FC<ScrollPageProps> = ({ children, section = ""}) => {

  return (
    <div id={section} className="sectionContainer">
        {children}
    </div>
  );
};

export default Section;